import React, { useState } from 'react';
import styled from 'styled-components';
import EcomStarRating from '../EcomStarRating';
import { getCurrencySymbol } from '../../../../FlyfishComponents/flyfishutils/utils';
import { AIIcon } from '../../../../FlyfishComponents/flyfishIcons/icons';

type Props = {
	customClassName;
	data;
	styleAdvisorCache;
	handleSubmit;
	onClickStyleAdvisor;
	onClose?;
	advisorTitle;
};

const EcomStyleAdvisorContent = styled.div`
	> div {
		&:nth-of-type(1) {
			margin-bottom: 15px;
			font-weight: bold !important;
			color: var(--selectedColor);
		}
	}
	> .ff-style-item {
		display: flex;
		margin-bottom: 20px;
		flex-direction: column;
		justify-content: center;
		cursor:pointer;
		&.hide{
			display:none;
		}
		&.show{
			display:flex;
		}
		> img {
			max-height: 68px;
			border-radius: 10px;
		}

		> div {
			&:nth-of-type(1) {
				margin-left: 20px;
			}
			.ff-chatbot-body1 {
				font-weight: 600;
				line-height: 1.3;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				word-break: break-word;
				overflow: hidden;
				margin-top: 12px;
				font-size:14px;
				&.animation-character {
					color: var(--black-10);
					overflow: hidden;
					animation: overlay-animation 0.5s ease-in-out infinite alternate;
				}
				@keyframes overlay-animation {
					0% {
						opacity: 0.5;
					}
					100% {
						opacity: 1;
					}
				}
			}
			.ff-chatbot-h3 {
				font-size: 18px !important;
				> sup {
					font-size: 11px !important;
				}
			}
		}
	}
	&.ff-ecom-monaco-cart-page{
		.ff-back-icon-ecom{
			display:block !important;
			position: absolute;
			right: -36px;
			top: -36px;
		
		}
	}
	&.ff-cart-page {
		background-color: var(--colorScale-8-1f);
		border-radius: 10px;
		padding: 20px;
		width: 15%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		padding-top: 14px;
		padding-right: 29px;
		position:relative;
		height: fit-content;
		.ff-back-icon-ecom{
			display:none;
		}
		>svg{
			position: absolute;
			right: 8px;
			top: 10px;
		}
	}
	.ff-style-img {
		margin-right: 15px;
		width: 150px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left:0px !important;
	    height:auto;
		border-radius: 10px;
		background-color: rgb(0 0 0 / 10%);
		
		>img{
			border-radius: 10px;
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	
	}
	}
`;

const EcomStyleAdvisor = ({
	customClassName,
	data,
	handleSubmit,
	onClickStyleAdvisor,
	onClose,
	advisorTitle
}: Props) => {
	const [showMore, setShowMore] = useState(false);
	return (
		<EcomStyleAdvisorContent className={customClassName}>
			<svg
				onClick={() => {
					onClose();
				}}
				className='ff-back-icon-ecom'
				xmlns='http://www.w3.org/2000/svg'
				width='20'
				height='20'
				viewBox='0 0 29.255 29.25'
				style={{ cursor: 'pointer' }}
			>
				<g
					id='Icon_ion-ios-close-outline'
					data-name='Icon ion-ios-close-outline'
					transform='translate(-3.372 -3.375)'
				>
					<path
						id='Path_20510'
						data-name='Path 20510'
						d='M28.343,7.657a14.627,14.627,0,1,0,0,20.686,14.632,14.632,0,0,0,0-20.686Zm-.865,19.821a13.4,13.4,0,1,1,0-18.956A13.423,13.423,0,0,1,27.478,27.478Z'
					/>
					<path
						id='Path_20511'
						data-name='Path 20511'
						d='M23.92,11.25l-5.934,5.92L12.08,11.278l-.83.83L17.156,18,11.25,23.892l.83.83,5.906-5.892,5.934,5.92.83-.83L18.816,18l5.934-5.92Z'
					/>
				</g>
			</svg>
			<AIIcon />
			<div className='ff-chatbot-h6'>{advisorTitle}</div>
			{data && data.length ? (
				<>
					{data[0].map((item, index) => {
						return (
							<div
								className={`ff-style-item ${index > 2 ? (showMore ? 'show' : 'hide') : ''
									}`}
								key={index}
								onClick={() => {
									//handleSubmit(item.title);
									onClickStyleAdvisor(item);
								}}
							>
								<div className='ff-style-img'>
									<img src={item.imageUrl} />
								</div>

								<div>
									<div className='ff-chatbot-body1'>{item.title}</div>
									<div style={{ margin: '4px 0px' }}>
										{item.rating && parseInt(item.rating) > 0 ? (
											<EcomStarRating
												userRating={item.rating}
												width={'9'}
												height={'9'}
												customClassName='ff-style-rating'
											/>
										) : null}
									</div>
									{parseInt(item.price) > 0 ? (
										<div
											className='ff-chatbot-h3'
											style={{ color: 'var(--selectedColor)' }}
										>
											<sup style={{ fontSize: '16px', marginRight: '4px' }}>
												{getCurrencySymbol(item.currency)}
											</sup>
											{item.price}
										</div>
									) : null}
								</div>
							</div>
						);
					})}
					{data && data.length > 3 && (
						<div
							onClick={() => {
								setShowMore(!showMore);
							}}
							style={{ color: 'var(--selectedColor)', cursor: 'pointer' }}
						>
							{showMore ? 'See Less' : 'See More'}
						</div>
					)}
				</>
			) : (
				Array.from(Array(3)).map((_, i) => {
					return (
						<div className='ff-style-item' style={{ marginBottom: '-28px' }}>
							<div className='ff-style-img' style={{ height: '220px' }}></div>
							<div>
								<div
									className='ff-chatbot-body1 animation-character'
									style={{ opacity: '10%' }}
								>
									▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆▆
								</div>
								<div style={{ margin: '4px 0px', visibility: 'hidden' }}>
									<EcomStarRating
										userRating={3}
										width={'9'}
										height={'9'}
										customClassName='ff-style-rating'
									/>
								</div>
								<div
									className='ff-chatbot-h3'
									style={{
										color: 'var(--selectedColor)',
										visibility: 'hidden',
									}}
								>
									<sup style={{ fontSize: '16px', marginRight: '4px' }}>$</sup>
									123
								</div>
							</div>
						</div>
					);
				})
			)}
		</EcomStyleAdvisorContent>
	);
};

export default EcomStyleAdvisor;
